{
 "Your trial's {n} AI conversations are used up; new chats go to your team.": "נוצלו {n} שיחות ה-AI של תקופת הניסיון; שיחות חדשות מועברות לצוות שלכם.",
 "Your free trial ends tomorrow.": "תקופת הניסיון החינמית מסתיימת מחר.",
 "Your free trial ends in {n} days.": "תקופת הניסיון החינמית מסתיימת בעוד {n} ימים.",
 "Your free trial has ended. The AI agent is paused; new chats go to your team.": "תקופת הניסיון החינמית הסתיימה. סוכן ה-AI מושהה; שיחות חדשות מועברות לצוות שלכם.",
 "We couldn't charge your card. We'll retry automatically, or update your payment now.": "לא הצלחנו לחייב את הכרטיס. ננסה שוב אוטומטית, או שתוכלו לעדכן את התשלום עכשיו.",
 "Your subscription is unpaid. The AI agent is paused until the balance is paid.": "המנוי לא שולם. סוכן ה-AI מושהה עד לתשלום היתרה.",
 "Your subscription has ended. The AI agent is paused.": "המנוי הסתיים. סוכן ה-AI מושהה.",
 "You've hit this month's safety limit for AI conversations; new chats go to your team.": "הגעתם למגבלת הבטיחות החודשית של שיחות AI; שיחות חדשות מועברות לצוות שלכם.",
 "You've used all {n} included AI conversations this month; extra ones are billed at ₪0.60.": "ניצלתם את כל {n} שיחות ה-AI הכלולות החודש; שיחות נוספות מחויבות ב-₪0.60.",
 "Payment received. Thank you!": "התשלום התקבל. תודה!",
 "The payment didn't go through": "התשלום לא עבר",
 "Cancel at the end of the current period? The AI agent stops when it ends.": "לבטל בסוף התקופה הנוכחית? סוכן ה-AI יפסיק לפעול כשהיא תסתיים.",
 "Your plan will end at the close of this period": "החבילה תסתיים בסוף התקופה הנוכחית",
 "Your plan will renew as usual": "החבילה תתחדש כרגיל",
 "{plan} plan": "חבילת {plan}",
 "Outstanding balance: {amount} incl. VAT.": "יתרה לתשלום: {amount} כולל מע\"מ.",
 "Pay now": "לתשלום עכשיו",
 "Keep my plan": "השארת החבילה",
 "Cancel plan": "ביטול החבילה",
 "Payment method": "אמצעי תשלום",
 "Card ending {last4}, charged automatically each period.": "כרטיס המסתיים ב-{last4}, מחויב אוטומטית בכל תקופה.",
 "Tax invoice-receipts are issued by Morning and emailed to {email}.": "חשבוניות מס קבלה מופקות ב-Morning ונשלחות במייל אל {email}.",
 "the owner": "בעל העסק",
 "No card on file. You'll add one on the secure payment page when you choose a plan.": "אין כרטיס שמור. תוסיפו כרטיס בעמוד התשלום המאובטח כשתבחרו חבילה.",
 "Online payment isn't switched on yet.": "התשלום המקוון עדיין לא הופעל.",
 "Contact us to subscribe.": "צרו קשר כדי להצטרף.",
 "Change plan": "החלפת חבילה",
 "Choose a plan": "בחירת חבילה",
 "Billing period": "תקופת חיוב",
 "Monthly": "חודשי",
 "Yearly · 2 months free": "שנתי · חודשיים מתנה",
 "Most popular": "הכי פופולרי",
 "/ year + VAT": "/ לשנה + מע\"מ",
 "/ month + VAT": "/ לחודש + מע\"מ",
 "{n} AI conversations a month": "{n} שיחות AI בחודש",
 "WhatsApp + website chat ({n} connected)": "WhatsApp + צ'אט באתר ({n} מחוברים)",
 "WhatsApp, Instagram, Messenger + website chat ({n} connected)": "WhatsApp, Instagram, Messenger + צ'אט באתר ({n} מחוברים)",
 "{n} team members": "{n} אנשי צוות",
 "Unlimited team members": "אנשי צוות ללא הגבלה",
 "{n} staff or rooms": "{n} אנשי צוות מטפלים או חדרים",
 "Unlimited staff and rooms": "אנשי צוות מטפלים וחדרים ללא הגבלה",
 "Automatic follow-ups": "מעקבים אוטומטיים",
 "No automatic follow-ups": "ללא מעקבים אוטומטיים",
 "CRM webhooks": "Webhooks ל-CRM",
 "No CRM webhooks": "ללא Webhooks ל-CRM",
 "Choice of the most capable AI model": "בחירה במודל ה-AI המתקדם ביותר",
 "Current plan": "החבילה הנוכחית",
 "Switch to {plan}": "מעבר ל-{plan}",
 "Choose {plan}": "בחירה ב-{plan}",
 "Only the owner can change the plan.": "רק בעל העסק יכול להחליף חבילה.",
 "Extra AI conversations beyond your plan: {price} each. Prices exclude {vat}% VAT.": "שיחות AI מעבר לחבילה: {price} לשיחה. המחירים אינם כוללים מע\"מ {vat}%.",
 "A one-time {fee} setup and onboarding fee applies to the first payment.": "דמי הקמה והטמעה חד-פעמיים של {fee} נגבים בתשלום הראשון.",
 "WhatsApp conversation fees are billed by Meta directly.": "עלויות שיחות WhatsApp מחויבות ישירות על ידי Meta.",
 "Invoices and charges": "חשבוניות וחיובים",
 "Date": "תאריך",
 "Description": "תיאור",
 "Total": "סה\"כ",
 "Status": "סטטוס",
 "Invoice": "חשבונית",
 "No charges yet.": "אין חיובים עדיין.",
 "Paid": "שולם",
 "Not completed": "לא הושלם",
 "Failed": "נכשל",
 "Retrying {date}": "ניסיון חוזר ב-{date}",
 "Due": "לתשלום",
 "Free trial until {date} ({n} days left). No card needed until you choose a plan.": "תקופת ניסיון חינמית עד {date} (נותרו {n} ימים). אין צורך בכרטיס עד שתבחרו חבילה.",
 "Your trial ended on {date}. Choose a plan to switch the AI agent back on.": "תקופת הניסיון הסתיימה ב-{date}. בחרו חבילה כדי להפעיל מחדש את סוכן ה-AI.",
 "Complimentary early-access plan. Thank you for being one of our first businesses.": "חבילת גישה מוקדמת ללא עלות. תודה שאתם מהעסקים הראשונים שלנו.",
 "This subscription has ended. Choose a plan to start again.": "המנוי הסתיים. בחרו חבילה כדי להתחיל מחדש.",
 "Payment failed several times, so the AI agent is paused. Pay the balance to switch it back on.": "התשלום נכשל מספר פעמים ולכן סוכן ה-AI מושהה. שלמו את היתרה כדי להפעיל אותו מחדש.",
 "Ends on {date}.": "מסתיים ב-{date}.",
 "Renews yearly on {date}.": "מתחדש שנתית ב-{date}.",
 "Renews monthly on {date}.": "מתחדש חודשית ב-{date}.",
 "Switches to {plan} (yearly) at renewal.": "יעבור ל-{plan} (שנתי) בחידוש.",
 "Switches to {plan} (monthly) at renewal.": "יעבור ל-{plan} (חודשי) בחידוש.",
 "AI conversations this trial": "שיחות AI בתקופת הניסיון",
 "AI conversations this month": "שיחות AI החודש",
 "Resets {date}.": "מתאפס ב-{date}.",
 "A conversation is one customer chat the AI handled in the period, however many messages it takes.": "שיחה היא צ'אט אחד עם לקוח שה-AI טיפל בו בתקופה, ללא קשר למספר ההודעות.",
 "You're on {plan} now": "עברתם ל-{plan}",
 "{plan} starts at your next renewal": "{plan} ייכנס לתוקף בחידוש הבא",
 "{plan}, yearly": "{plan}, שנתי",
 "{plan}, monthly": "{plan}, חודשי",
 "Upgrades start now; we charge your saved card for the difference for the rest of this period. Downgrades and billing-period changes start at your next renewal.": "שדרוג נכנס לתוקף מיד; נחייב את הכרטיס השמור בהפרש עד סוף התקופה. הורדת חבילה ושינוי תקופת חיוב נכנסים לתוקף בחידוש הבא.",
 "{plan}, first year": "{plan}, שנה ראשונה",
 "{plan}, first month": "{plan}, חודש ראשון",
 "Setup and onboarding (one time)": "הקמה והטמעה (חד-פעמי)",
 "VAT {vat}%": "מע\"מ {vat}%",
 "Total today": "סה\"כ לתשלום היום",
 "Your card is saved securely by our payment provider and charged automatically each year. Cancel any time; the plan runs to the end of the paid period.": "הכרטיס נשמר באופן מאובטח אצל ספק התשלומים ומחויב אוטומטית מדי שנה. אפשר לבטל בכל עת; החבילה פעילה עד סוף התקופה ששולמה.",
 "Your card is saved securely by our payment provider and charged automatically each month. Cancel any time; the plan runs to the end of the paid period.": "הכרטיס נשמר באופן מאובטח אצל ספק התשלומים ומחויב אוטומטית מדי חודש. אפשר לבטל בכל עת; החבילה פעילה עד סוף התקופה ששולמה.",
 "Invoice details": "פרטי חשבונית",
 "Business name on invoice": "שם העסק בחשבונית",
 "Business number": "מספר עסק",
 "Needed for VAT-deductible invoices": "נדרש לחשבוניות מוכרות לניכוי מע\"מ",
 "Invoice email": "מייל לחשבוניות",
 "Defaults to the owner's email": "ברירת המחדל: המייל של בעל העסק",
 "Back": "חזרה",
 "Confirm change": "אישור השינוי",
 "Continue to secure payment": "המשך לתשלום מאובטח",
 "until {date}": "עד {date}",
 "Now complimentary": "עבר לחבילה ללא עלות",
 "Comp": "ללא עלות",
 "Trial extended by 14 days": "תקופת הניסיון הוארכה ב-14 ימים",
 "+14d trial": "+14 ימי ניסיון",
 "Restart trial": "התחלת ניסיון מחדש",
 "Trial": "ניסיון",
 "Active": "פעיל",
 "Payment failed": "התשלום נכשל",
 "Unpaid": "לא שולם",
 "Trial ended": "הניסיון הסתיים",
 "Cancelled": "בוטל",
 "Complimentary": "ללא עלות",
 "Plan": "חבילה",
 "AI cost this month": "עלות AI החודש",
 "Please add your payment card again by {date} so your plan renews without interruption.": "נא להזין שוב את כרטיס האשראי עד {date} כדי שהחבילה תתחדש ללא הפסקה.",
 "Update card": "עדכון כרטיס",
 "Your card was saved": "הכרטיס נשמר",
 "We moved to a new payment account, so saved cards need to be added again. Please update your card by {date}.": "עברנו לחשבון סליקה חדש, ולכן יש להזין שוב כרטיסים שמורים. נא לעדכן את הכרטיס עד {date}.",
 "Replace card": "החלפת כרטיס",
 "A {amount} card check is charged and credited on your next bill.": "בעדכון כרטיס נגבה {amount} לאימות, והסכום מזוכה בחיוב הבא.",
 "Credit for your next bill: {amount}.": "זיכוי לחיוב הבא: {amount}.",
 "Manage": "ניהול",
 "Start a free trial for {name}? The AI stops when it ends unless they choose a plan.": "להתחיל תקופת ניסיון עבור {name}? סוכן ה-AI ייעצר בסופה אם לא תיבחר חבילה.",
 "Trial updated": "תקופת הניסיון עודכנה",
 "Budget saved": "התקציב נשמר",
 "Billing for {name}": "חיוב עבור {name}",
 "Now": "כרגע",
 "Make complimentary": "העברה לחבילה ללא עלות",
 "Complimentary: free on the chosen plan, no trial end. Founding is the early-access plan with no limits.": "ללא עלות: חינם בחבילה שנבחרה, בלי סוף ניסיון. Founding היא חבילת הגישה המוקדמת ללא מגבלות.",
 "Extend trial by (days)": "הארכת הניסיון ב-(ימים)",
 "Start a trial of (days)": "תקופת ניסיון של (ימים)",
 "Extend trial": "הארכת ניסיון",
 "Start trial": "התחלת ניסיון",
 "Save budget": "שמירת תקציב",
 "This month so far: ${amount}": "החודש עד כה: ${amount}",
 "Waive the setup fee": "ויתור על דמי ההקמה",
 "Setup fee waived": "דמי ההקמה בוטלו",
 "Apply": "החלה",
 "{n} saved cards were removed. Paying businesses now see a request to add their card again.": "{n} כרטיסים שמורים הוסרו. עסקים משלמים יתבקשו כעת להזין שוב כרטיס.",
 "Payment account": "חשבון סליקה",
 "Morning connected": "Morning מחובר",
 "key": "מפתח",
 "plugin": "תוסף",
 "Not connected": "לא מחובר",
 "Set MORNING_API_KEY_ID, MORNING_API_KEY_SECRET and MORNING_PLUGIN_ID as Worker secrets to take payments.": "כדי לגבות תשלומים יש להגדיר את MORNING_API_KEY_ID, MORNING_API_KEY_SECRET ו-MORNING_PLUGIN_ID כ-secrets של ה-Worker.",
 "{paying} paying businesses · {cards} saved cards · {waiting} waiting for a new card": "{paying} עסקים משלמים · {cards} כרטיסים שמורים · {waiting} ממתינים לכרטיס חדש",
 "Switch payment account…": "החלפת חשבון סליקה…",
 "Switch payment account": "החלפת חשבון סליקה",
 "In Cloudflare (Workers → whatsapp-schedule → Settings → Variables and Secrets), replace MORNING_API_KEY_ID, MORNING_API_KEY_SECRET and MORNING_PLUGIN_ID with the new Morning account's values.": "ב-Cloudflare (Workers → whatsapp-schedule → Settings → Variables and Secrets) מחליפים את MORNING_API_KEY_ID, MORNING_API_KEY_SECRET ו-MORNING_PLUGIN_ID בערכים של חשבון ה-Morning החדש.",
 "Then forget the saved cards here. They belong to the old account and can't be charged from the new one.": "אחר כך מוחקים כאן את הכרטיסים השמורים. הם שייכים לחשבון הישן ואי אפשר לחייב אותם מהחשבון החדש.",
 "Each paying business sees a request to add its card again before its next renewal. A renewal without a card fails and is retried as usual.": "כל עסק משלם יתבקש להזין שוב כרטיס לפני החידוש הבא. חידוש ללא כרטיס נכשל ומנוסה שוב כרגיל.",
 "Type RESET to confirm": "הקלידו RESET לאישור",
 "Forget saved cards": "מחיקת הכרטיסים השמורים",
 "No card on file. Add one so your plan renews.": "אין כרטיס שמור. הוסיפו כרטיס כדי שהחבילה תתחדש.",
 "Update your card first to change plans.": "כדי להחליף חבילה, עדכנו קודם את הכרטיס.",
 "terms of use": "תנאי השימוש",
 "Finish your payment to switch on the AI agent.": "השלימו את התשלום כדי להפעיל את סוכן ה-AI.",
 "Complete payment": "השלמת תשלום",
 "Your account is ready. Choose your plan below and complete the payment to switch on the AI agent.": "החשבון מוכן. בחרו חבילה למטה והשלימו את התשלום כדי להפעיל את סוכן ה-AI.",
 "Awaiting payment": "ממתין לתשלום",
 "Get started with RELAYZA": "מתחילים עם RELAYZA",
 "Renews automatically each {period}. Cancel any time; the plan runs to the end of the paid period. Your AI agent is set up with you within 3 business days of payment.": "מתחדש אוטומטית כל {period}. אפשר לבטל בכל עת; החבילה פעילה עד סוף התקופה ששולמה. נקים איתכם את סוכן ה-AI תוך 3 ימי עסקים מהתשלום.",
 "year": "שנה",
 "month": "חודש",
 "Your details": "הפרטים שלכם",
 "Also where invoices are sent": "לכתובת זו יישלחו גם החשבוניות",
 "Mobile phone": "טלפון נייד",
 "Choose a password": "בחרו סיסמה",
 "This email already has an account.": "לכתובת המייל הזו כבר יש חשבון.",
 "Sign in and choose a plan": "התחברו ובחרו חבילה",
 "Payment is processed securely by Morning and Grow. We never see your card number.": "התשלום מתבצע באופן מאובטח דרך Morning ו-Grow. אנחנו לא רואים את מספר הכרטיס.",
 "I have read and accept the ": "קראתי ואני מסכים/ה ל",
 "I confirm I am 18 or older, and I have read and accept the ": "אני מאשר/ת שאני בן/בת 18 ומעלה, וקראתי ואני מסכים/ה ל",
 "First name": "שם פרטי",
 "Last name": "שם משפחה",
 "Country": "מדינה",
 "Online payment is being activated. Email us and we'll complete your purchase:": "התשלום המקוון בהפעלה בימים אלה. כתבו לנו ונשלים איתכם את הרכישה:",
 "Add your key": "הוספת מפתח",
 "Claude AI usage included": "שימוש ב-AI של Claude כלול",
 "Bring your own Claude API key": "נדרש מפתח API של Claude שלכם",
 "Extra conversations {price} each": "שיחות נוספות {price} לשיחה",
 "Extra AI conversations beyond your plan: {price} each, or {byo} on the plans where you bring your own Claude key, since Anthropic already bills you for those conversations. Prices exclude {vat}% VAT.": "שיחות AI מעבר למסלול: {price} לשיחה, או {byo} במסלולים שבהם המפתח של Claude הוא שלכם, כי Anthropic כבר מחייבת אתכם על אותן שיחות. המחירים ללא מע״מ {vat}%.",
 "This business pays by card. It changes its plan from its own billing page; you can still waive its setup fee here.": "העסק משלם בכרטיס אשראי ומחליף חבילה מעמוד החיוב שלו; כאן אפשר עדיין לוותר לו על דמי ההקמה.",
 "{n} tokens (30d)": "{n} טוקנים (30 יום)",
 "Own Anthropic key": "מפתח Anthropic של העסק",
 "We paid ${amount}": "שילמנו ${amount}",
 "Custom budget": "תקציב מותאם",
 "Plan default": "ברירת המחדל של החבילה",
 "No budget: its own key": "ללא תקציב: מפתח של העסק",
 "Trial credit applies": "חל קרדיט הניסיון",
 "No budget": "ללא תקציב",
 "of": "מתוך",
 "AI budget…": "תקציב AI…",
 "Plan default: ${amount} a month, the most this plan can earn us in a month, so a paying business never reaches it in normal use.": "ברירת המחדל של החבילה: ${amount} בחודש, המקסימום שהחבילה יכולה להכניס לנו בחודש, כך שעסק משלם לא מגיע אליו בשימוש רגיל.",
 "Default: ${amount} a month, the allowance every complimentary and Founding business gets.": "ברירת מחדל: ${amount} בחודש, המכסה שכל עסק ללא עלות או Founding מקבל.",
 "No default: it runs on its own Anthropic key, so Anthropic bills the business, not us.": "אין ברירת מחדל: העסק עובד על מפתח Anthropic משלו, ולכן Anthropic מחייבת אותו ולא אותנו.",
 "No default during the trial: the trial's $5 AI credit limits what our key spends.": "אין ברירת מחדל בתקופת הניסיון: קרדיט ה-AI של $5 בניסיון מגביל את מה שהמפתח שלנו מוציא.",
 "No default: this plan doesn't include AI usage on our key.": "אין ברירת מחדל: החבילה הזו לא כוללת שימוש ב-AI על המפתח שלנו.",
 "AI budget for {name}": "תקציב AI עבור {name}",
 "The most AI may cost on this business in a calendar month. Once it is reached the agent stops answering, new chats go to the business's team, and the team gets one alert. It starts again on the 1st, or as soon as you raise it.": "הסכום המקסימלי שה-AI יכול לעלות על העסק הזה בחודש קלנדרי. כשמגיעים אליו הסוכן מפסיק לענות, שיחות חדשות עוברות לצוות של העסק, והצוות מקבל התראה אחת. הוא חוזר לעבוד ב-1 לחודש, או מיד כשמעלים את התקציב.",
 "Custom budget (USD a month)": "תקציב מותאם (דולר לחודש)",
 "Leave empty to follow the plan default.": "השאירו ריק כדי לעבוד לפי ברירת המחדל של החבילה.",
 "Use the plan default": "חזרה לברירת המחדל של החבילה",
 "Claude API key": "מפתח API של Claude",
 "Key set": "מוגדר",
 "Not set": "לא מוגדר",
 "ending in": "מסתיים ב-",
 "Our Anthropic key pays for trials, Growth, Pro and complimentary businesses. It is the Worker secret ANTHROPIC_API_KEY: in Cloudflare, Workers & Pages → whatsapp-schedule → Settings → Variables and Secrets. Create the key at console.anthropic.com.": "מפתח ה-Anthropic שלנו משלם על תקופות ניסיון, Growth, Pro ועסקים ללא עלות. הוא ה-secret של ה-Worker בשם ANTHROPIC_API_KEY: ב-Cloudflare, Workers & Pages → whatsapp-schedule → Settings → Variables and Secrets. יוצרים את המפתח ב-console.anthropic.com.",
 "A business with its own key adds it on its AI agent page (owners only). Lite and Starter need one once the trial ends.": "עסק עם מפתח משלו מוסיף אותו בעמוד סוכן ה-AI שלו (בעלים בלבד). Lite ו-Starter צריכים מפתח כזה כשתקופת הניסיון נגמרת.",
 "Default monthly AI budgets": "תקציבי AI חודשיים כברירת מחדל",
 "none, own key": "ללא, מפתח של העסק",
 "Trial: ${amount} credit for the whole trial": "ניסיון: קרדיט של ${amount} לכל תקופת הניסיון",
 "Billing isn't available in the app.": "החיוב לא זמין באפליקציה."
}
